import { takeLatest } from "redux-saga/effects";
import actions from "../constants/dashboardActions";
import { createWatcher } from "../utils/sagas";
import * as dashboardWorker from "../workers/dashboard/dashboardWorker";

export const getDashboardOverviewWatcher = createWatcher(
  actions.GET_DASHBOARD_OVERVIEW,
  dashboardWorker.getDashboardOverviewWorker,
  takeLatest
);

export const getDashboardIncomingOverviewWatcher = createWatcher(
  actions.GET_DASHBOARD_INCOMING_OVERVIEW,
  dashboardWorker.getDashboardIncomingOverviewWorker,
  takeLatest
);

export const getDashboardOverviewBagWatcher = createWatcher(
  actions.GET_DASHBOARD_OVERVIEW_BAG,
  dashboardWorker.getDashboardOverviewBagWorker,
  takeLatest
);

export const getDashboardIncomingOverviewBagWatcher = createWatcher(
  actions.GET_DASHBOARD_INCOMING_OVERVIEW_BAG,
  dashboardWorker.getDashboardIncomingOverviewBagWorker,
  takeLatest
);

export const getDashboardIncomingBagsClickableWatcher = createWatcher(
  actions.GET_DASHBOARD_INCOMING_BAGS_CLICKABLE,
  dashboardWorker.getDashboardIncomingBagsClickableWorker,
  takeLatest
);

export const getDashboardOutscanBagsClickableWatcher = createWatcher(
  actions.GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE,
  dashboardWorker.getDashboardOutscanBagsClickableWorker,
  takeLatest
);

export const getDashboardOutscanToCpShipmentsClickableWatcher = createWatcher(
  actions.GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE,
  dashboardWorker.getDashboardOutscanToCpShipmentsClickableWorker,
  takeLatest
);

export const getDashboardOutscanToCpBagsClickableWatcher = createWatcher(
  actions.GET_DASHBOARD_OUTSCAN_TO_CP_BAGS_CLICKABLE,
  dashboardWorker.getDashboardOutscanToCpBagsClickableWorker,
  takeLatest
);

export const getDashboardInscanShipmentsClickableWatcher = createWatcher(
  actions.GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE,
  dashboardWorker.getDashboardInscanShipmentsClickableWorker,
  takeLatest
);

export const getDashboardOutscanShipmentsClickableWatcher = createWatcher(
  actions.GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE,
  dashboardWorker.getDashboardOutscanShipmentsClickableWorker,
  takeLatest
);

export const getDashboardIncomingShipmentsClickableWatcher = createWatcher(
  actions.GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE,
  dashboardWorker.getDashboardIncomingShipmentsClickableWorker,
  takeLatest
);

export const getDashboardInscanBagsClickableWatcher = createWatcher(
  actions.GET_DASHBOARD_INSCAN_BAGS_CLICKABLE,
  dashboardWorker.dashboardInscanBagsClickableWorker,
  takeLatest
);

export const getRegexPatternWatcher = createWatcher(
  actions.GET_REGEX_PATTERN,
  dashboardWorker.getRegexPatternWorker,
  takeLatest
);

export const getAnnouncementsWatcher = createWatcher(
  actions.GET_ANNOUNCEMENTS,
  dashboardWorker.getAnnouncementsWorker,
  takeLatest
);
